<app-traitement-data titre="O2 effort" [sousTitre]="patient!.tableauDeBord?.debit02Effort?.date | aLaDateDu"
    [statut]="patient!.tableauDeBord?.debit02Effort?.value ? 'info' : 'warning'">
    {{ patient!.tableauDeBord?.debit02Effort?.value ?? 'Pas de donnée' }}
</app-traitement-data>